"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var linkUtils_1 = require("@/react-app/common/utils/linkUtils");
var validatePasswordFormat_1 = __importDefault(require("./validatePasswordFormat"));
var validator = {
    isWebhookUrl: function (webhookUrl) {
        // regex copied from Apollo
        // https://gitlab.besedo.com/moderation-platform/apollo-web-services/-/blob/master/lib/models/site.js#L52
        var regex = /^(?:(?:https?):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i;
        return regex.test(webhookUrl) && /^https/.test(webhookUrl);
    },
    isEmail: function (email) {
        // the email regex is the same as backend in apollo, reference: http://emailregex.com/
        var regex = 
        // eslint-disable-next-line no-useless-escape
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
        return regex.test(email);
    },
    isDomain: function (domain) {
        return (0, linkUtils_1.isDomain)(domain);
    },
    /**
     * Validate a URL
     * @param  {string} string - URL
     * @return {boolean}
     */
    isUrl: function (url) {
        var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
        return typeof url === 'string' && !!url.match(URL_REGEXP);
    },
    isValidPasswordFormat: validatePasswordFormat_1.default,
};
exports.default = validator;
